import { X } from "lucide-react";
import type React from "react";
import { useUI } from "@/features/ui";

const TOP_UP_URL = "https://ai.gliadirector.com/profile";

export const TopUpModal: React.FC = () => {
  const { showTopUpModal, setShowTopUpModal } = useUI();

  if (!showTopUpModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-slate-900 rounded-lg shadow-xl border border-slate-700 w-full max-w-md mx-4">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700">
          <h2 className="text-lg font-semibold text-slate-200">Insufficient Credits</h2>
          <button
            onClick={() => setShowTopUpModal(false)}
            className="p-1 rounded hover:bg-slate-800 text-slate-400 hover:text-slate-200 transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        <div className="px-4 py-6">
          <p className="text-slate-300 mb-6">
            You don't have enough credits to continue. Please top up your account to keep using the
            service.
          </p>
          <div className="flex gap-3 justify-end">
            <button
              onClick={() => setShowTopUpModal(false)}
              className="px-4 py-2 text-sm rounded bg-slate-700 text-slate-200 hover:bg-slate-600 transition-colors"
            >
              Cancel
            </button>
            <a
              href={TOP_UP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 text-sm rounded bg-indigo-600 text-white hover:bg-indigo-500 transition-colors"
              onClick={() => setShowTopUpModal(false)}
            >
              Top Up
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
